export enum CustomElementStatus {
  UNDEFINED = "undefined",
  DEFINED = "defined"
}
